module.exports = __webpack_public_path__ + "media/chip1.172b025d.mp3";